import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {Location} from '@angular/common';
import {Observable} from 'rxjs';

import {LocalStorageService} from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthPageGuardService implements CanActivate {

  constructor(
    private router: Router,
    // private appService: AppService,
    // private logger: NGXLogger,
    private localStorageService: LocalStorageService
  ) {}

  canActivate(
    // route: ActivatedRouteSnapshot,
    // state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // const user = this.appService.currentUser;
    //
    // if (user) {
    //   // Redirecciona a la pagina de inicio
    //   this.logger.info('usuario logueado, redirecciona a la pagina de inicio');
    //   this.router.navigate(['/admin', 'usuarios']);
    //   return false;
    // }
    //
    // return true;

    const token = this.localStorageService.getItem('t');
    console.info('AuthPageGuardService token', token);
    if (token) {
      // Redirecciona a la pagina de inicio
      console.info('usuario logueado, redirecciona a la pagina de inicio');
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}

@Injectable({
  providedIn: 'root',
})
export class PrivatePageGuardService implements CanActivate {
  private redirectPages: {
    login: string;
    home: string;
    forbidden: string;
  };

  constructor(
    private router: Router,
    private location: Location,
    // private appService: AppService,
    // private permissionsService: PermissionsService,
    // private redirectService: RedirectService,
    // private logger: NGXLogger,
    private localStorageService: LocalStorageService
  ) {
    this.redirectPages = {
      login: 'auth',
      home: '/',
      forbidden: '403',
    };
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // const user = this.appService.currentUser;
    //
    // if (!user) {
    //   // Guarda la url para hacer la redireccion despues del login del usuario
    //   this.redirectService.saveInitialUrl(this.location.path());
    //
    //   // Se asegura de borrar el LocalStorage
    //   this.appService.clearSessionInfoFromLocalStorage();
    //
    //   // Redirecciona a la pagina de login
    //   this.logger.info(
    //     'no hay usuario logueado, redirecciona al formulario de login'
    //   );
    //   this.router.navigate([this.redirectPages.login]);
    //   return false;
    // }

    const token = this.localStorageService.getItem('t');
    if (!token) {
      // Redirecciona a la pagina de login
      console.info(
        'no hay usuario logueado, redirecciona al formulario de login'
      );
      this.router.navigate([this.redirectPages.login]);
      return false;
    }
    return true;

    // Resetea el redirectService
    // this.redirectService.resetInitialUrl();
    //
    // if (!route.data) {
    //   if (!route.data.id) {
    //     // this.logger.warn('la ruta no tiene definido el "id"');
    //   }
    //   if (!route.data.action) {
    //     // this.logger.warn('la ruta no tiene definido el "action"');
    //   }
    //   // Redirecciona a la pagina de inicio
    //   // this.logger.info('redirecciona a la pagina de inicio');
    //   this.router.navigate([this.redirectPages.home]);
    //   return false;
    // }
    //
    // const permissionsUtil = new PermissionsUtil(this.permissionsService);
    // const hasAccess = permissionsUtil.isAllowed(
    //   `${route.data.id}.${route.data.action}`,
    //   user._role
    // );
    // if (!hasAccess) {
    //   // this.logger.warn(
    //   //   `el usuario no tiene acceso a "${route.data.id}.${route.data.action}", redirecciona a la pagina "${this.redirectPages.forbidden}"`
    //   // );
    //
    //   // Redirecciona
    //   this.router.navigate([this.redirectPages.forbidden]);
    //   return false;
    // }
    //
    // return true;
  }
}
